import { useQuery } from '@tanstack/react-query';
import { validateInviteToken } from '@api/invites';

export const useInviteValidation = (token: string | null) => (
  useQuery({
    queryKey: ['invite', 'validate', token],
    queryFn: () => validateInviteToken(token!),
    enabled: Boolean(token),
    retry: false,
    staleTime: 60 * 1000,
  })
);
